/**
 * tm() returns compiled message ASTs under @nuxtjs/i18n.
 * Use tmResolved() to get plain strings/objects for lists.
 */
export function useResolvedI18n() {
  const i18n = useI18n()
  const { t, tm, rt, locale } = i18n

  function isMessageAst(node: object): boolean {
    return 'type' in node && typeof (node as { type: unknown }).type === 'number'
  }

  function resolve(node: unknown): unknown {
    if (node == null || typeof node === 'string' || typeof node === 'number' || typeof node === 'boolean') {
      return node
    }
    if (Array.isArray(node)) {
      return node.map(resolve)
    }
    if (typeof node === 'object') {
      if (isMessageAst(node)) {
        return rt(node as Parameters<typeof rt>[0])
      }
      const result: Record<string, unknown> = {}
      for (const [key, value] of Object.entries(node as Record<string, unknown>)) {
        result[key] = resolve(value)
      }
      return result
    }
    return node
  }

  function tmResolved<T = unknown>(key: string): T {
    // Ensure computeds invalidate when language switches (same page component reused)
    void locale.value
    return resolve(tm(key)) as T
  }

  return { t, tm, rt, locale, tmResolved }
}
